export default function () {
  return function (scope, element, attrs) {
    if (scope.$last) {
      // try{
      //   $('#product-slider').slick("unslick");
      //   $('#product-carousel').slick("unslick");
      // }catch(e){
      // }
      // productSlider();
    }
  };
}


// WEBPACK FOOTER //
// ./src/js/eshop/Directives/on-repeat-end.js